<!--
  Same layout as voyage-credit-refund.component.html — see that component's
  header for why this is a literal copy rather than a shared template. Class
  names are unchanged (`.vcr__*`) since the stylesheet is shared, not copied.
-->
<div class="vcr">
  <div class="vcr__head">
    <h4 class="vcr__title">Credit usage and refund</h4>
  </div>

  <div class="vcr__body" id="scrollcustom">
    <div class="vcr__body-inner">
      <div class="vcr__card">
        <div class="vcr__ledger-top">
          <span class="vcr__ledger-label">Remaining</span>
          <span class="vcr__ledger-value">
            <b>{{ remaining == null ? '—' : remaining }}</b>
            <span class="vcr__ledger-of">of {{ purchased }} credits</span>
          </span>
        </div>

        <div class="vcr__bar" *ngIf="purchased > 0 && remaining != null">
          <span class="vcr__bar-seg is-used" [style.width.%]="usedPct"></span>
        </div>

        <table class="vcr__tbl">
          <tr class="vcr__row vcr__row--dim">
            <td>Purchased</td>
            <td class="vcr__calc"></td>
            <td class="vcr__n">{{ purchased }}</td>
          </tr>

          <tr class="vcr__row vcr__row--dim" *ngIf="remaining != null">
            <td><span class="vcr__dot is-used"></span>Used</td>
            <td class="vcr__calc"></td>
            <td class="vcr__n">{{ used }}</td>
          </tr>

          <tr class="vcr__row vcr__row--dim" *ngIf="refundApproved">
            <td>Refunded</td>
            <td class="vcr__calc" *ngIf="showMoney">
              {{ refundedCredits }} &times; {{ unitCost | number: '1.2-2' }}
            </td>
            <td class="vcr__calc" *ngIf="!showMoney"></td>
            <td class="vcr__n">{{ refundedCredits }}</td>
          </tr>

          <tr class="vcr__row vcr__row--total">
            <td>Remaining</td>
            <td class="vcr__calc"></td>
            <td class="vcr__n">{{ remaining == null ? '—' : remaining }}</td>
          </tr>
          <tr class="vcr__row vcr__row--money" *ngIf="refundApproved && showMoney">
            <td>Refunded value</td>
            <td class="vcr__calc"></td>
            <td class="vcr__n">US$ {{ refundedValue | number: '1.2-2' }}</td>
          </tr>
        </table>
      </div>

      <div class="vcr__card vcr__card--state" *ngIf="!canRequestRefund">
        <div class="vcr__banner is-wait" *ngIf="refundPending">
          <mat-icon class="material-icons-outlined">schedule</mat-icon>
          <span>Refund requested. {{ toiFinished
            ? 'The TOI has ended, so these credits cannot be spent while it is reviewed.'
            : 'Your credits stay spendable until it is approved.' }}</span>
        </div>
        <div class="vcr__banner is-good" *ngIf="refundApproved">
          <mat-icon class="material-icons-outlined">check_circle</mat-icon>
          <span>
            Refund approved. The refunded credits have been returned and can no longer be spent.
          </span>
        </div>
        <div class="vcr__banner is-bad" *ngIf="refundDeclined">
          <mat-icon class="material-icons-outlined">cancel</mat-icon>
          <span>Refund declined. {{ toiFinished
            ? 'The TOI has ended, so these credits can no longer be spent — please contact support if this is unexpected.'
            : 'Your credits remain available to spend.' }}</span>
        </div>
        <div class="vcr__banner is-info" *ngIf="allUsed && !refundPending && !refundApproved && !refundDeclined">
          <mat-icon class="material-icons-outlined">info</mat-icon>
          <span>All credits used. There is nothing left to refund — re-task to continue.</span>
        </div>
      </div>

      <form class="vcr__card" *ngIf="canRequestRefund" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <div class="vcr__amount">
          <span class="vcr__amount-label">Refunding</span>
          <span class="vcr__amount-value">
            <b>{{ remaining }}</b> unused credits
            <span class="vcr__amount-money" *ngIf="showMoney">
              &middot; US$ {{ estimatedRefund | number: '1.2-2' }}
            </span>
          </span>
        </div>

        <p class="vcr__stranded" *ngIf="stranded">
          These credits are below the cost of any action, so they cannot be spent on this task.
        </p>

        <p class="vcr__note is-block" *ngIf="!toiFinished" aria-live="polite">
          <mat-icon class="material-icons-outlined">schedule</mat-icon>
          <span>You can submit this once the time of interest (TOI) finishes.</span>
        </p>

        <label class="vcr__field-label" for="vfcrReason">Reason for the request</label>
        <textarea
          id="vfcrReason"
          class="vcr__reason"
          formControlName="reason"
          rows="4"
          [maxlength]="maxMsgLength"
          placeholder="Tell us why you are requesting this refund"
        ></textarea>

        <div class="vcr__counter">
          <span class="vcr__counter-err">{{ errorMessage }}</span>
          <span class="vcr__counter-n">{{ reasonLength }}/{{ maxMsgLength }}</span>
        </div>

        <p class="vcr__note">
          Final amount is confirmed on approval and reflects any credits spent in the meantime.
        </p>
      </form>
    </div>
  </div>

  <div class="vcr__foot">
    <button class="custom-button" type="button" (click)="onCancel()">
      {{ canRequestRefund ? 'Cancel' : 'Close' }}
    </button>
    <button
      *ngIf="canRequestRefund"
      mat-stroked-button
      class="submit"
      type="button"
      [disabled]="!canSubmitRefund || formGroup.invalid || submitting"
      [matTooltip]="!toiFinished ? 'Available once the time of interest (TOI) finishes' : ''"
      (click)="onSubmit()"
    >
      {{ submitting ? 'Submitting…' : 'Request refund' }}
    </button>
  </div>
</div>
